export const SCREEN_TYPE = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

export const PRINT_SCREEN_PARAMS = {
  default: {
    width: '1275px',
    height: '1803px',
  },
  safari: {
    width: '1100px',
    height: '1400px',
  },
};
